<div fxLayout="column" fxFlex>

    <!-- Header  -->
    <div>
        <div fxLayoutAlign="space-between center" class="layout-padd divider" >
            <mat-icon class="clicked" (click)="closeSide()">navigate_next</mat-icon>
            <mat-icon class="great-ico clicked myDisabledUserKey" matTooltip="{{'fidelityComponent.print'|translate}}" matTooltipPosition="below" (click)="goPrint()" angulartics2On="click" angularticsAction="openPrintOrderFromSideData" angularticsCategory="clientOrders">print
            </mat-icon>
        </div>
    </div>

    <!-- Content -->
    <div class="scrolled">

        <!-- Point of sale infos -->
        <div>

            <div class="divider layout-padd">
                <span class=" mat-subheading-1">{{'noteComponent.point_of_sales'|translate}}</span>
            </div>

            <div fxLayout="column" fxLayoutGap="5px" class="layout-padd">

                <!-- Point of sale name|city -->
                <div fxLayout="row" fxLayoutGap="10px">

                    <div>
                        <span class="mat-title boldest">{{order.point_of_sale.denomination| uppercase}}</span>
                    </div>

                    <div>
                        <span class="mat-title">-</span>
                    </div>

                    <div>
                        <span class="mat-title">{{order.point_of_sale.city | uppercase}}</span>
                    </div>

                </div>

            </div>

        </div>

        <!-- Order infos -->
        <div>

            <div class="divider layout-padd">
                <span class=" mat-subheading-1">{{"Informations"|translate}}</span>
            </div>

            <div class="layout-padd">

                <!-- Sale method name -->
                <div fxLayout="row" fxLayoutAlign="space-between center">

                    <div>
                        <span class="mat-subheading-1">{{"dateOrder.status"|translate}}</span>
                    </div>

                    <div>
                        <span class="mat-subheading-1 boldest secondary-ico" *ngIf="order.id_order_level === 0">{{"dateOrder.notTreated"|translate}}</span>
                        <span class="mat-subheading-1 boldest great-ico" *ngIf="order.id_order_level === 1">{{"dateOrder.closed"|translate}}</span>
                        <span class="mat-subheading-1 boldest warn-ico" *ngIf="order.id_order_level === -1">{{"dateOrder.canceled"|translate}}</span>
                    </div>

                </div>

                <!-- Sale method name -->
                <div fxLayout="row" fxLayoutAlign="space-between center">

                    <div>
                        <span class="mat-subheading-1">{{"dateOrder.saleMethod"|translate}}</span>
                    </div>

                    <div>
                        <span class="mat-subheading-1 boldest">{{order.sale_method.name | uppercase}}</span>
                    </div>

                </div>

                <!-- Date creation -->
                <div fxLayout="row" fxLayoutAlign="space-between center">

                    <div>
                        <span class="mat-subheading-1">{{"dateOrder.passed"|translate}}</span>
                    </div>

                    <div>
                        <span class="mat-subheading-1 boldest">{{order.date_creation | dateFilter:'DD-MM-YYYY'}}</span>
                        <span class="mat-subheading-1">&nbsp;&nbsp;{{"dateOrder.at"|translate}}&nbsp;&nbsp;</span>
                        <span class="mat-subheading-1 boldest">{{order.date_creation | dateFilter:'HH:mm'}}</span>
                    </div>

                </div>

                <!-- Date execution -->
                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="order.sale_method.enable_shipping_cost < 1">

                    <div>
                        <span class="mat-subheading-1">{{"dateOrder.for"|translate}}</span>
                    </div>

                    <div>
                        <span class="mat-subheading-1 boldest">{{order.date_execution | dateFilter:'DD-MM-YYYY'}}</span>
                        <span class="mat-subheading-1">&nbsp;&nbsp;{{"dateOrder.at"|translate}}&nbsp;&nbsp;</span>
                        <span class="mat-subheading-1 boldest">{{order.hour_execution | hourFilter}}</span>
                    </div>

                </div>

                <!-- Mondial relay traking link -->
                <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="order.tracking_link">

                    <div>
                        <span class="mat-subheading-1">{{"dateOrder.trackPackage"|translate}}</span>
                    </div>

                    <div>
                        <button mat-icon-button class="great-ico" (click)="openTrackingLink()"><mat-icon>local_shipping</mat-icon></button>
                    </div>

                </div>

                <div *ngIf="order.infos_note.length > 0">

                    <div *ngFor="let info of order.infos_note" fxLayout="row" fxLayoutAlign="space-between center">

                        <div>
                            <span class="mat-subheading-1">{{info.name | capitalize}}</span>
                        </div>

                        <div>
                            <span class="mat-subheading-1 boldest">{{info.value | uppercase}}</span>
                        </div>

                    </div>

                </div>

            </div>

        </div>

        <!-- Order Details -->
        <div class="divider">

            <div class="divider layout-padd">
                <span class=" mat-subheading-1">{{"dateOrder.details"|translate}}</span>
            </div>

            <div class="layout-padd">

                <div *ngFor="let prod of order.basket; let last = last" class="layout-padd" fxLayoutAlign="space-between center" [class.divider]="!last">

                    <div fxFlex="10" fxLayoutAlign="start center">
                        <span class="mat-subheading-1">{{prod.quantity}}</span>
                    </div>

                    <div fxFlex fxLayoutAlign="start center" fxLayoutGap="10px">

                        <img *ngIf="prod.product.image_link.length > 0" src="{{prod.product.image_link[0] | prodSizeFilter:72}}" class="basket-prod-img">
                        <img *ngIf="prod.product.image_link.length < 1" src="/assets/img/not-found.png" class="side-prod-img">
                        <span class="mat-subheading-1">{{prod.name | capitalize}}</span>
                        <!-- <span class="mat-subheading-1">{{prod.display_lang.name | capitalize}}</span> -->

                    </div>

                    <div fxFlex="20" fxLayoutAlign="start center">
                        <span class="mat-subheading-1">{{prod.total_ttc_str}}</span>
                    </div>

                </div>

            </div>

        </div>

        <!-- Totals -->
        <div class="layout-padd">

            <div fxLayout="column" *ngIf="order.sale_method.enable_shipping_cost > 0 || order.sale_method.enable_delivery > 0">

                <!-- Sub total -->
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">

                    <div>
                        <span class="mat-subheading-1">{{"basket.sub-total"|translate}}</span>
                    </div>

                    <div *ngIf="order.sale_method.enable_delivery > 0">
                        <span class="mat-title">{{(order.total - order.order_address.delivery_price )| priceFilter: order.currency.symbol : order.currency.decimal}}</span>
                    </div>

                    <div *ngIf="order.sale_method.enable_shipping_cost > 0">
                        <span class="mat-title">{{(order.total - order.order_address.shipping_price) | priceFilter: order.currency.symbol : order.currency.decimal}}</span>
                    </div>

                </div>

                <!-- Shipping -->
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" *ngIf="order.sale_method.enable_shipping_cost > 0">

                    <div>
                        <span *ngIf="order.order_address.country_name" class="mat-subheading-1">{{"basket.shipping-cost"|translate}}
              {{'(' + (order.order_address.country_name | capitalize) +')'}}</span>
                        <span *ngIf="!order.order_address.country_name" class="mat-subheading-1">{{"basket.shipping-cost"|translate}} :</span>
                    </div>

                    <div>
                        <span class="mat-subheading-1" *ngIf="order.order_address.shipping_price > 0">{{order.order_address.shipping_price_str}}</span>
                        <span class="mat-subheading-1" *ngIf="order.order_address.shipping_price === 0">gratuit</span>
                    </div>

                </div>

                <!-- Delivery -->
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px" *ngIf="order.sale_method.enable_delivery > 0">

                    <div>
                        <span *ngIf="order.order_address.city_name" class="mat-subheading-1">{{"basket.shipping-cost"|translate}}
              {{'(' + (order.order_address.city_name | capitalize) +')'}}</span>
                        <span *ngIf="!order.order_address.city_name" class="mat-subheading-1">{{"basket.shipping-cost"|translate}} :</span>
                    </div>

                    <div>
                        <span class="mat-subheading-1" *ngIf="order.order_address.delivery_price > 0">{{order.order_address.delivery_price_str}}</span>
                        <span class="mat-subheading-1" *ngIf="order.order_address.delivery_price === 0">{{"BasketEnorderComponent.free"|translate}}  </span>
                    </div>

                </div>

                <!-- All total -->
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">

                    <div>
                        <span class="mat-subheading-1">{{"basket.total"|translate}}</span>
                    </div>

                    <div>
                        <span class="mat-title boldest">{{order.total_str}}</span>
                    </div>

                </div>

            </div>

            <!-- Total for click n collect -->
            <div fxLayout="row" fxLayoutAlign="space-between center" *ngIf="order.sale_method.enable_shipping_cost < 1 && order.sale_method.enable_delivery < 1">
                <span class="mat-title">{{"basket.total"|translate}}</span>
                <span class="mat-title boldest">{{order.total_str}}</span>
            </div>

        </div>


        <!-- Moyens de paiement -->
        <div>

            <div class="divider layout-padd">
                <span class=" mat-subheading-1">{{"endorder.means-of-payments"|translate}}</span>
            </div>

            <div fxLayout="column" class="layout-padd">

                <div *ngIf="order.order_payments.length < 1">
                    <span class="mat-caption">{{"endorder.counter-payment"|translate}}</span>
                </div>

                <div *ngIf="order.order_payments.length > 0">

                    <div *ngFor="let orderPayment of order.order_payments">

                        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
                            <span class="mat-caption" *ngIf="orderPayment.id_payment_mean === -42 && orderPayment.captured >0">{{(orderPayment.total < 0 ? 'dateOrder.refund' : 'dateOrder.payment')|translate}} {{"dateOrder.withCard"|translate}}</span>
                            <span class="mat-caption" *ngIf="orderPayment.id_payment_mean === -42 && orderPayment.captured < 1">{{(orderPayment.total < 0 ? 'dateOrder.refund' : 'dateOrder.payment')|translate}} {{"dateOrder.withCard"|translate}}</span>
                            <span class="mat-caption" *ngIf="orderPayment.id_payment_mean === -15 && orderPayment.captured >0">{{(orderPayment.total < 0 ? 'dateOrder.refund' : 'dateOrder.payment')|translate}} {{"dateOrder.withCagn"|translate}}</span>
                            <span class="mat-caption" *ngIf="orderPayment.id_payment_mean === -15 && orderPayment.captured< 1">{{(orderPayment.total < 0 ? 'dateOrder.refund' : 'dateOrder.payment')|translate}} {{"dateOrder.withCagn"|translate}} </span>
                            <span class="mat-caption" *ngIf="orderPayment.id_payment_mean === -43">{{(orderPayment.total < 0 ? 'dateOrder.refund' : 'dateOrder.payment')|translate}} {{"dateOrder.by"|translate}}  <img src="assets/img/paypal-logo/paypal_logo.png"  class="h-4"></span>
                            <span class="mat-caption boldest">{{orderPayment.total_str}}</span>
                        </div>

                    </div>

                </div>

            </div>




        </div>

    </div>

    <div class="fill-rest"></div>

</div>
